export class PaymentStatuses {
    public static PAID = 'PAID';
    public static UNPAID = 'UNPAID';
    public static CANCELED = 'CANCELED';
    public static PARTIAL_PAID = 'PARTIAL_PAID';
    public static OVER_PAID = 'OVER_PAID';
    public static PRE_AUTH = 'PRE_AUTH';
}
